export default __webpack_public_path__ + "static/media/OpenGHG_Logo_Portrait.c51170ed.svg";